import { useCallback } from 'react';
import { useTriggerSelector } from './useTriggerSelector';

export const useGetFrequencySelector = () => {
  const trigger = useTriggerSelector();

  return useCallback(() => trigger?.frequency, [trigger?.frequency]);
};
